import _ from 'lodash';

export default class Inventory {
  constructor(data) {
    // It's a good practice to use lodash getters
    this.productId = _.get(data, 'productId');
    this.storeId = _.get(data, 'storeId');
    this.date = _.get(data, 'date');
    this.name = _.get(data, 'name');
    this.unit = _.get(data, 'unit');
    this.quantity = _.get(data, 'quantity', undefined);
    this.quantitySold = _.get(data, 'quantitySold', undefined);
    this.quantityProductSold = _.get(data, 'quantityProductSold', undefined);
    this.reception = _.get(data, 'reception', undefined);
    this.stockJ = _.get(data, 'stockJ', undefined);
    this.stockJ1 = _.get(data, 'stockJ1', undefined);
    this.week = _.get(data, 'week', undefined);
    this.year = _.get(data, 'year', undefined);
  }

  get displayName() {
    return this.name;
  }

  get displayUnit() {
    return this.unit;
  }

  get getDifference() {
    if (this.quantity === undefined || this.quantitySold === undefined) {
      return null;
    }
    let difference = this.quantity - this.quantitySold;
    difference = difference.toFixed(2);
    return difference;
  }

  get displayDifference() {
    const difference = this.getDifference;
    if (difference === null) {
      return 'N.C';
    }
    return (difference > 0 ? '+' : '') + difference;
  }

  get displayDifferenceByProduct() {
    const difference = this.getDifference;
    const quantityProductSold = parseInt(_.get(this, 'quantityProductSold', 0), 10);
    if (difference === null || quantityProductSold === 0) {
      return 'N.C';
    }
    let result = difference / quantityProductSold;
    if (this.unit === 'kg') {
      result *= 1000;
    }
    result = result.toFixed(2);
    return result;
  }
}
